import React from "react";
import { possiblePeriodStatuses } from "@/store/actions/periodStatus";

const DashboardCard = ({ value, subtitle }) => {
	return (
		<div>
			<div
				className="form-section flex grow justify-center items-center"
				style={{
					padding: "10px 0",
					minWidth: "300px",
					boxSizing: "border-box",
					minHeight: "150px",
				}}
			>
				<div
					className="section-header"
					style={{ marginBottom: "5px" }}
				>
					<div
						style={{
							display: "flex",
							fontSize: "2em",
							fontWeight: "bold",
							color: "#333",
							justifyContent: "center",
						}}
					>
						{value}
					</div>
					<div style={{ display: "flex", fontSize: "1.2em", color: "#555555", justifyContent: "center" }}>
						{subtitle}
					</div>
				</div>
			</div>
		</div>
	);
};

const PayrollStatusCard = ({ stats, countPerStatus }) => {

	const statusColors = {
		"open": "#FF0",
		"overdue": "#F00",
		"concluded": "#0F0",
	}

	const totalPercentage = Object.values(stats).reduce((acc, curr) => acc + curr, 0);
	const percentagePerStatus = {

	}

	if (!Object.keys(stats).every(key => stats[key])) return;

	Object.keys(stats).map((status) => {
		percentagePerStatus[status] = (stats[status] || 0) / totalPercentage * 100;
	})

	console.log('percentagePerStatus', {percentagePerStatus,totalPercentage});

	return (
		<div className="col-xs-12">
			<div
				className="form-section width-full"
				style={{
					padding: "10px 10px",
					display: "flex",
					flexDirection: "row",
					gap: "20px",
				}}
			>
				{/* Display Section */}
				<div style={{ width: "50%" }}>
					<div
						className="section-header flex justify-center"
						style={{
							marginBottom: "5px",
							fontSize: "1.5em",
							fontWeight: "bold",
							color: "#333",
						}}
					>
						Payrolls This Month
					</div>
					<div>
						<div
							className="flex flex-row"
							style={{
								width: "100%",
								marginBottom: 10,
								padding: 8,
								borderRadius: "10px",
							}}
						>

							{
								Object.keys(percentagePerStatus).map((status, index) => {
									const percentage = percentagePerStatus[status];
									const isLast = index === Object.keys(percentagePerStatus).length - 1;

									return (
										<div
											key={status}
											style={{
												width: `${percentage}%`,
												display: `${percentage == 0 ? "none" : "flex"}`,
												flexDirection: "column",
											}}
										>
											<div
												style={{
													backgroundColor: statusColors[status],
													padding: 8,
													width: "100%",
													borderTopLeftRadius: "12px",
													borderBottomLeftRadius: "12px",
													borderTopRightRadius: `${isLast ? "12px" : "0"}`,
													borderBottomRightRadius: `${isLast ? "12px" : "0"}`,
												}}
											></div>
											<div className="flex justify-center">
												<span
													style={{
														display: `${percentage != 0 ? "flex" : "none"}`,
														fontSize: "1.2em",
														color: "#555555",
													}}
												>
													{stats[status]}
												</span>
											</div>
										</div>
									)
								})
							}

						</div>
					</div>
				</div>

				{/* Text Section */}
				<div
					className="flex flex-row items-center justify-evenly flex-wrap"
					style={{
						width: "50%",
					}}
				>
					<div>
						{Object.keys(countPerStatus).map((status) => {
							return (
								<div>
									<div
										className="flex justify-center"
										key={status}
										style={{
											fontSize: "2em",
											fontWeight: "bold",
											// color: statusColors[status],
											color: "#333",
										}}
									>
										{countPerStatus[status]}
									</div>

									<div
										className="flex justify-center"
										style={{
											fontSize: "1.2em",
											color: "#555555",
										}}
									>
										{status}
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

const FeatureUsageCard = ({ everroll, clientDataRequest, rtiAutomation, clientReview }) => {
	return (
		<div
			className="flex form-section width-full flex-col"
			style={{
				padding: "10px 10px",
			}}
		>
			{/* Header */}
			<div
				className="section-header"
				style={{
					marginBottom: "5px",
					display: "flex",
					fontSize: "1.5em",
					fontWeight: "bold",
					color: "#333",
					justifyContent: "flex-start",
				}}
			>
				Feature Usage
			</div>
			{/* Divs Container */}
			<div
				className="container-div"
				style={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					marginBottom: 10,
					//marginLeft: 20,
				}}
			>
				<ProgressBar
					title="Everroll"
					percent={everroll}
				/>
				<ProgressBar
					title="Client Data Request"
					percent={clientDataRequest}
				/>
				<ProgressBar
					title="RTI Automation"
					percent={rtiAutomation}
				/>
				<ProgressBar
					title="Client Review"
					percent={clientReview}
				/>
			</div>
		</div>
	);
};

const ProgressBar = ({ title, percent }) => {
	return (
		<>
			<div
				style={{
					display: "flex",
					fontSize: "1.2em",
					color: "#555",
					justifyContent: "flex-start",
					width: "100%",
				}}
			>
				{title}
			</div>
			<div style={{ marginBottom: "20px" }}>
				<div
					style={{
						width: "100%",
						borderRadius: "10px",
						backgroundColor: "#F00",
						position: "relative",
						height: "20px",
						overflow: "hidden",
						border: "2px solid #BBB",
					}}
				>
					<div
						style={{
							width: `${percent}%`,
							height: "100%",
							borderRadius: "10px",
							backgroundColor: "#0F0",
							position: "absolute",
							top: 0,
							left: 0,
						}}
					></div>
				</div>
			</div>
		</>
	);
};
export { DashboardCard, PayrollStatusCard, FeatureUsageCard };
